import { render, staticRenderFns } from "./Vocabulary.vue?vue&type=template&id=3bced6d0&scoped=true&"
import script from "./Vocabulary.vue?vue&type=script&lang=js&"
export * from "./Vocabulary.vue?vue&type=script&lang=js&"
import style0 from "./Vocabulary.vue?vue&type=style&index=0&id=3bced6d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bced6d0",
  null
  
)

export default component.exports